import {doc} from '../docs.js';
import {getVolume} from 'engine/pads/Pad.js';
import {initializeEffect} from 'components/effects/constants.js';

let SENDS = ['A', 'B', 'C', 'D', 'E'];
doc(
    "audioFX",
    {
        "name": ""
    },
    "Creates an audio fx (to be put somewhere",
    () => 1,
    {
        inlets: 2
    }
);
export const audioFX = (object, name) => {
    return ([msg]) => {
        let effect = initializeEffect(name(), object.sequencerEngine);
        if (!effect) {
            return undefined;
        }
        return [effect];
    };
};

doc(
    "mixChannel",
    {
    },
    "Controls effects in the mix channel"
);
export const mixChannel  = (object) => {
    return ([effect]) => {
        // dont allow
        let sequencerEngine = object.sequencerEngine;
        let chain = sequencerEngine.channelMixer.masterChannel.effectsChain;
        let existing = chain.effects.find(x => x.name === effect.name);
        if (existing) {
            return [existing];
        } else {
            chain.addEffect(effect);
            return [effect];
        }
    };
};

doc(
    "sendChannel",
    {
        name: ""
    },
    "Controls effects in a send channel",
    () => 2,
    {
        outlets: ["Effects", "Send"]
    }
);
export const sendChannel = (object, name) => {
    return ([effect]) => {
        // dont allow
        let sequencerEngine = object.sequencerEngine;
        let send = sequencerEngine.sends.sends.find(x => x.name.toLowerCase() === name().toLowerCase());
        let chain = send.effectsChain;
        let existing = chain.effects.find(x => x.name === effect.name);
        if (existing) {
            return [existing, send];
        } else {
            chain.addEffect(effect);
            return [effect, send];
        }
    };
};

doc(
    "sendVolumes",
    {
        name: ""
    },
    "Controls send volumes of tracks",
    (n) => 1,
    {
    }
);
export const sendVolumes = (object, name) => {
    return ([msg]) => {
        // dont allow

        if (!Array.isArray(msg)) {
            return;
        }

        let [trackNumber, volume] = msg;
        let track = object.sequencerEngine.tracks[trackNumber]
        if (!track) {
            return;
        }

        let parameter = track.sendNodeVolumeParameters[SENDS.indexOf(name())];
        if (!parameter) {
            return;
        }

        let vol = getVolume(volume, -80, 2, 1);
        parameter.set(vol, false);
    };
};

doc(
    "groupSendVolumes",
    {
        name: ""
    },
    "Controls send volumes of groups of tracks",
    (n) => 1,
    {
    }
);
export const groupSendVolumes = (object, name) => {
    return ([msg]) => {
        // dont allow

        if (!Array.isArray(msg)) {
            return;
        }

        let [groupNumber, volume] = msg;
        let group = object.sequencerEngine.groups.groups[groupNumber];
        if (!group) {
            return;
        }
        for (let track of group.tracks) {
            if (!track) {
                return;
            }
            
            let parameter = track.sendNodeVolumeParameters[SENDS.indexOf(name())];
            if (!parameter) {
                return;
            }
            
            let vol = getVolume(volume, -80, 2, 1);
            parameter.set(vol, false);
        };
    }
};


export const effects ={
    audioFX,
    mixChannel,
    sendChannel,
    sendVolumes,
    groupSendVolumes
};
